const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Standard Model Grid ───────────────────────────────
function DiagramStandardModel() {
  const W = 900, H = 480;

  const particles = [
    // Quarks - Gen I
    { x:90,  y:60,  label:'u', name:'Up',      mass:'2.2 MeV', charge:'⅔',  spin:'½', color:'#27ae60', textColor:'#fff' },
    { x:90,  y:160, label:'d', name:'Down',    mass:'4.7 MeV', charge:'-⅓', spin:'½', color:'#27ae60', textColor:'#fff' },
    // Quarks - Gen II
    { x:220, y:60,  label:'c', name:'Charm',   mass:'1.28 GeV',charge:'⅔',  spin:'½', color:'#27ae60', textColor:'#fff' },
    { x:220, y:160, label:'s', name:'Strange', mass:'96 MeV',  charge:'-⅓', spin:'½', color:'#27ae60', textColor:'#fff' },
    // Quarks - Gen III
    { x:350, y:60,  label:'t', name:'Top',     mass:'173 GeV', charge:'⅔',  spin:'½', color:'#27ae60', textColor:'#fff' },
    { x:350, y:160, label:'b', name:'Bottom',  mass:'4.18 GeV',charge:'-⅓', spin:'½', color:'#27ae60', textColor:'#fff' },
    // Leptons - Gen I
    { x:90,  y:260, label:'e', name:'Electron',mass:'0.511 MeV',charge:'-1', spin:'½', color:'#e67e22', textColor:'#fff' },
    { x:90,  y:360, label:'νe',name:'e-Neutrino',mass:'<1 eV', charge:'0',  spin:'½', color:'#e67e22', textColor:'#fff' },
    // Leptons - Gen II
    { x:220, y:260, label:'μ', name:'Muon',    mass:'105.7 MeV',charge:'-1', spin:'½', color:'#e67e22', textColor:'#fff' },
    { x:220, y:360, label:'νμ',name:'μ-Neutrino',mass:'<0.17 MeV',charge:'0',spin:'½',color:'#e67e22', textColor:'#fff' },
    // Leptons - Gen III
    { x:350, y:260, label:'τ', name:'Tau',     mass:'1.777 GeV',charge:'-1', spin:'½', color:'#e67e22', textColor:'#fff' },
    { x:350, y:360, label:'ντ',name:'τ-Neutrino',mass:'<18.2 MeV',charge:'0',spin:'½',color:'#e67e22', textColor:'#fff' },
    // Gauge Bosons
    { x:510, y:60,  label:'γ', name:'Photon',  mass:'0',       charge:'0',  spin:'1', color:'#c0392b', textColor:'#fff' },
    { x:510, y:160, label:'g', name:'Gluon',   mass:'0',       charge:'0',  spin:'1', color:'#c0392b', textColor:'#fff' },
    { x:510, y:260, label:'W', name:'W Boson', mass:'80.4 GeV',charge:'±1', spin:'1', color:'#c0392b', textColor:'#fff' },
    { x:510, y:360, label:'Z', name:'Z Boson', mass:'91.2 GeV',charge:'0',  spin:'1', color:'#c0392b', textColor:'#fff' },
    // Scalar Boson
    { x:660, y:60,  label:'H', name:'Higgs',   mass:'125 GeV', charge:'0',  spin:'0', color:'#f39c12', textColor:'#fff' },
  ];

  const bw = 100, bh = 90;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Standard Model — Elementary Particles Overview</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Column headers */}
        {['Generation I','Generation II','Generation III'].map((t,i) => (
          <text key={i} x={90+i*130+50} y={22} textAnchor="middle" fontSize="12" fontWeight="700" fill="#1a1a2e">{t}</text>
        ))}
        <text x={560} y={22} textAnchor="middle" fontSize="12" fontWeight="700" fill="#c0392b">Gauge Bosons</text>
        <text x={710} y={22} textAnchor="middle" fontSize="12" fontWeight="700" fill="#f39c12">Scalar</text>

        {/* Row labels */}
        <text x={28} y={110} textAnchor="middle" fontSize="11" fontWeight="700" fill="#27ae60" transform="rotate(-90,28,110)">QUARKS</text>
        <text x={28} y={315} textAnchor="middle" fontSize="11" fontWeight="700" fill="#e67e22" transform="rotate(-90,28,315)">LEPTONS</text>

        {/* Divider line */}
        <line x1={45} y1={210} x2={780} y2={210} stroke="#ccc" strokeWidth="1.5" strokeDasharray="4,3"/>

        {particles.map((p, i) => {
          const rx = p.x - 5, ry = p.y - 5;
          return (
            <g key={i}>
              <rect x={rx} y={ry} width={bw} height={bh} rx={6}
                fill={p.color} stroke="#333" strokeWidth="1.2" opacity="0.92"/>
              {/* Symbol */}
              <text x={rx+50} y={ry+46} textAnchor="middle" fontSize="26" fontWeight="700" fill="#fff">{p.label}</text>
              {/* Name */}
              <text x={rx+50} y={ry+64} textAnchor="middle" fontSize="10" fill="#fff" opacity="0.9">{p.name}</text>
              {/* Mass top-left */}
              <text x={rx+4} y={ry+13} fontSize="8.5" fill="#fff" opacity="0.85">{p.mass}</text>
              {/* Charge */}
              <text x={rx+4} y={ry+26} fontSize="8.5" fill="#fff" opacity="0.85">Q={p.charge}</text>
              {/* Spin */}
              <text x={rx+4} y={ry+37} fontSize="8.5" fill="#fff" opacity="0.85">s={p.spin}</text>
            </g>
          );
        })}

        {/* Legend */}
        {[['#27ae60','Quarks'],['#e67e22','Leptons'],['#c0392b','Gauge Bosons'],['#f39c12','Scalar Boson']].map(([col,lbl],i)=>(
          <g key={i}>
            <rect x={100+i*190} y={458} width={14} height={14} rx={3} fill={col}/>
            <text x={118+i*190} y={470} fontSize="11" fill="#333">{lbl}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>All confirmed elementary particles of the Standard Model. Antiparticles are not shown — each particle has a corresponding antiparticle with opposite charge.</div>
    </div>
  );
}

// ── Diagram 2: Wave-Particle Duality ─────────────────────────────
function DiagramWaveParticle() {
  const W = 860, H = 300;
  // Generate wave
  const wavePoints = [];
  for (let x = 0; x <= 400; x += 4) {
    const y = 100 + 55 * Math.sin((x / 400) * Math.PI * 6);
    wavePoints.push(`${x+40},${y}`);
  }
  const wavePath = 'M ' + wavePoints.join(' L ');

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Wave–Particle Duality — Two Faces of the Same Quantum Object</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Left: Wave behaviour */}
        <rect x={20} y={20} width={400} height={260} rx={8} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5"/>
        <text x={220} y={50} textAnchor="middle" fontSize="14" fontWeight="700" fill="#2E75B6">Wave Behaviour</text>
        <path d={wavePath} fill="none" stroke="#2E75B6" strokeWidth="2.5"/>
        {/* interference fringes */}
        {[0,1,2,3,4].map(i => (
          <rect key={i} x={70+i*70} y={175} width={30} height={80} rx={2}
            fill={`rgba(46,117,182,${0.7 - i*0.1})`} opacity="0.7"/>
        ))}
        <text x={220} y={273} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Double-slit interference pattern</text>

        {/* Right: Particle behaviour */}
        <rect x={440} y={20} width={400} height={260} rx={8} fill="#fff5f5" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={640} y={50} textAnchor="middle" fontSize="14" fontWeight="700" fill="#c0392b">Particle Behaviour</text>
        {/* Dots (particle hits) */}
        {[
          [520,120],[580,90],[620,140],[560,170],[640,110],[700,95],[660,155],[590,130],
          [530,160],[620,80],[680,140],[550,105],[700,160],[580,145],[640,175],[660,90],
          [590,175],[520,90],[700,120],[560,75]
        ].map(([px,py],i) => (
          <circle key={i} cx={px} cy={py} r={5} fill="#c0392b" opacity="0.7"/>
        ))}
        <text x={640} y={273} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Discrete photon/electron impacts on detector</text>

        {/* Connecting arrow */}
        <text x={430} y={155} textAnchor="middle" fontSize="22" fill="#7B0D0D" fontWeight="700">⟺</text>
        <text x={430} y={175} textAnchor="middle" fontSize="10" fill="#7B0D0D">same</text>
        <text x={430} y={188} textAnchor="middle" fontSize="10" fill="#7B0D0D">entity</text>
      </svg>
      <div style={S.dCaption}>An electron fired at a double slit produces wave-like interference — yet arrives at the detector as a single localised particle. Both descriptions are necessary.</div>
    </div>
  );
}

// ── Diagram 3: Feynman Diagram — Electron-Electron Scattering ────
function DiagramFeynman() {
  const W = 860, H = 340;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Feynman Diagrams — Visualising Particle Interactions</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* e-e scattering via photon */}
        <rect x={20} y={20} width={380} height={300} rx={8} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5"/>
        <text x={210} y={48} textAnchor="middle" fontSize="13" fontWeight="700" fill="#2E75B6">Electron–Electron Scattering (QED)</text>
        {/* Incoming e1 */}
        <line x1={60} y1={100} x2={175} y2={170} stroke="#c0392b" strokeWidth="2.5"/>
        <polygon points="170,163 185,175 168,180" fill="#c0392b"/>
        <text x={45} y={95} fontSize="12" fill="#c0392b" fontWeight="700">e⁻</text>
        {/* Incoming e2 */}
        <line x1={60} y1={240} x2={175} y2={170} stroke="#c0392b" strokeWidth="2.5"/>
        <polygon points="170,162 185,165 170,178" fill="#c0392b"/>
        <text x={45} y={255} fontSize="12" fill="#c0392b" fontWeight="700">e⁻</text>
        {/* Virtual photon */}
        {[0,1,2,3,4,5,6,7].map(i => {
          const x1 = 175 + i*20, x2 = 175 + (i+1)*20, y1 = 170 + (i%2===0?-8:8);
          return <line key={i} x1={x1} y1={170} x2={x2} y2={y1} stroke="#f39c12" strokeWidth="2.2"/>;
        })}
        <text x={210} y={148} textAnchor="middle" fontSize="11" fill="#f39c12" fontWeight="700">γ (virtual)</text>
        {/* Vertex dots */}
        <circle cx={175} cy={170} r={5} fill="#2E75B6"/>
        <circle cx={335} cy={170} r={5} fill="#2E75B6"/>
        {/* Outgoing e1 */}
        <line x1={335} y1={170} x2={360} y2={100} stroke="#c0392b" strokeWidth="2.5"/>
        <polygon points="352,106 365,97 366,112" fill="#c0392b"/>
        <text x={362} y={95} fontSize="12" fill="#c0392b" fontWeight="700">e⁻</text>
        {/* Outgoing e2 */}
        <line x1={335} y1={170} x2={360} y2={240} stroke="#c0392b" strokeWidth="2.5"/>
        <polygon points="352,234 365,243 352,248" fill="#c0392b"/>
        <text x={362} y={255} fontSize="12" fill="#c0392b" fontWeight="700">e⁻</text>
        <text x={210} y={310} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Repulsion mediated by virtual photon exchange</text>

        {/* Beta decay */}
        <rect x={440} y={20} width={400} height={300} rx={8} fill="#fff5f5" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={640} y={48} textAnchor="middle" fontSize="13" fontWeight="700" fill="#c0392b">Beta Minus (β⁻) Decay (Weak Force)</text>
        {/* n incoming */}
        <line x1={460} y1={80} x2={560} y2={170} stroke="#27ae60" strokeWidth="2.5"/>
        <text x={453} y={76} fontSize="12" fill="#27ae60" fontWeight="700">n</text>
        {/* p outgoing */}
        <line x1={560} y1={170} x2={660} y2={80} stroke="#27ae60" strokeWidth="2.5"/>
        <text x={662} y={76} fontSize="12" fill="#27ae60" fontWeight="700">p</text>
        {/* W- boson */}
        {[0,1,2,3,4,5,6,7].map(i => {
          const t = i / 7;
          const x = 560 + t * 100;
          const y = 170 + t * 80 + (i%2===0 ? -8 : 8);
          const xn = 560 + (t+1/7)*100;
          const yn = 170 + (t+1/7)*80;
          return <line key={i} x1={x} y1={y} x2={xn} y2={yn} stroke="#9b59b6" strokeWidth="2.5"/>;
        })}
        <text x={620} y={235} textAnchor="middle" fontSize="11" fill="#9b59b6" fontWeight="700">W⁻ (virtual)</text>
        {/* Vertex */}
        <circle cx={560} cy={170} r={5} fill="#c0392b"/>
        <circle cx={660} cy={250} r={5} fill="#c0392b"/>
        {/* e- */}
        <line x1={660} y1={250} x2={760} y2={200} stroke="#c0392b" strokeWidth="2.5"/>
        <text x={763} y={197} fontSize="12" fill="#c0392b" fontWeight="700">e⁻</text>
        {/* antineutrino */}
        <line x1={660} y1={250} x2={760} y2={295} stroke="#e67e22" strokeWidth="2.5" strokeDasharray="6,3"/>
        <text x={763} y={298} fontSize="12" fill="#e67e22" fontWeight="700">ν̄e</text>
        <text x={640} y={310} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">d quark → u quark + W⁻; W⁻ → e⁻ + ν̄e</text>
      </svg>
      <div style={S.dCaption}>Feynman diagrams are not cartoons — each diagram corresponds to a precise mathematical term in the perturbative expansion of the interaction amplitude.</div>
    </div>
  );
}

// ── Diagram 4: Forces and their Ranges ──────────────────────────
function DiagramForces() {
  const W = 860, H = 320;
  const forces = [
    { name:'Strong Nuclear',  carrier:'Gluon (g)',  range:'~10⁻¹⁵ m',  rel:'1',          color:'#27ae60', barW:340 },
    { name:'Electromagnetic', carrier:'Photon (γ)', range:'∞',          rel:'~10⁻²',      color:'#2E75B6', barW:240 },
    { name:'Weak Nuclear',    carrier:'W, Z Boson', range:'~10⁻¹⁸ m',  rel:'~10⁻⁶',      color:'#9b59b6', barW:120 },
    { name:'Gravity',         carrier:'Graviton(?)',range:'∞',          rel:'~10⁻³⁸',     color:'#e67e22', barW:30  },
  ];
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>The Four Fundamental Forces — Relative Strength and Range</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <text x={430} y={22} textAnchor="middle" fontSize="11" fill="#555" fontStyle="italic">Relative strength (logarithmic — actual ratios span 40 orders of magnitude)</text>
        {forces.map((f, i) => (
          <g key={i}>
            <text x={180} y={60+i*62} textAnchor="end" fontSize="12" fontWeight="700" fill={f.color}>{f.name}</text>
            <text x={180} y={76+i*62} textAnchor="end" fontSize="10" fill="#555">{f.carrier}</text>
            <rect x={190} y={48+i*62} width={f.barW} height={24} rx={4} fill={f.color} opacity="0.8"/>
            <text x={196+f.barW} y={65+i*62} fontSize="10" fill="#333" fontWeight="700">{f.rel}</text>
            <text x={600} y={60+i*62} fontSize="11" fill="#333">Range: <tspan fontWeight="700" fill={f.color}>{f.range}</tspan></text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>Gravity is by far the weakest force — yet dominates at cosmic scales because it is long-range and always attractive. The strong force is the most powerful but extremely short-ranged.</div>
    </div>
  );
}

// ── Diagram 5: Quark Composition of Hadrons ──────────────────────
function DiagramHadrons() {
  const W = 860, H = 300;
  const quarkColor = { u:'#27ae60', d:'#2E75B6', s:'#9b59b6' };

  function Particle({ cx, cy, r, quarks, name, charge, label }) {
    const angles = quarks.length === 2
      ? [0, Math.PI]
      : [Math.PI/6, Math.PI/6 + 2*Math.PI/3, Math.PI/6 + 4*Math.PI/3];
    const qr = r * 0.42;
    return (
      <g>
        <circle cx={cx} cy={cy} r={r} fill="#f5f5f5" stroke="#aaa" strokeWidth="1.5"/>
        {quarks.map((q, i) => {
          const a = angles[i];
          const qx = cx + (r-qr-6) * Math.cos(a);
          const qy = cy + (r-qr-6) * Math.sin(a);
          return (
            <g key={i}>
              <circle cx={qx} cy={qy} r={qr} fill={quarkColor[q] || '#888'} opacity="0.85"/>
              <text x={qx} y={qy+4} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">{q}</text>
            </g>
          );
        })}
        <text x={cx} y={cy+r+16} textAnchor="middle" fontSize="11" fontWeight="700" fill="#1a1a2e">{name}</text>
        <text x={cx} y={cy+r+29} textAnchor="middle" fontSize="10" fill="#7B0D0D">{charge}</text>
      </g>
    );
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Quark Composition of Common Hadrons (Baryons and Mesons)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Baryons label */}
        <text x={270} y={22} textAnchor="middle" fontSize="13" fontWeight="700" fill="#7B0D0D">Baryons (3 quarks)</text>
        {/* Mesons label */}
        <text x={660} y={22} textAnchor="middle" fontSize="13" fontWeight="700" fill="#2E75B6">Mesons (quark–antiquark)</text>

        <Particle cx={100} cy={130} r={60} quarks={['u','u','d']} name="Proton" charge="Q = +1"/>
        <Particle cx={260} cy={130} r={60} quarks={['u','d','d']} name="Neutron" charge="Q = 0"/>
        <Particle cx={420} cy={130} r={60} quarks={['u','d','s']} name="Lambda (Λ)" charge="Q = 0"/>

        <Particle cx={590} cy={130} r={50} quarks={['u','d']} name="Pion (π⁺)" charge="Q = +1"/>
        <Particle cx={700} cy={130} r={50} quarks={['u','s']} name="Kaon (K⁺)" charge="Q = +1"/>
        <Particle cx={800} cy={130} r={50} quarks={['u','u']} name="ρ meson (ρ⁺)" charge="Q = +1"/>

        {/* Divider */}
        <line x1={530} y1={30} x2={530} y2={270} stroke="#ddd" strokeWidth="1.5" strokeDasharray="5,3"/>

        {/* Legend */}
        {[['u','#27ae60','Up'],['d','#2E75B6','Down'],['s','#9b59b6','Strange']].map(([q,c,n],i)=>(
          <g key={i}>
            <circle cx={30} cy={220+i*22} r={8} fill={c} opacity="0.85"/>
            <text x={42} y={225+i*22} fontSize="10" fill="#333">{n} quark</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>Quarks are never observed in isolation — they are permanently confined inside hadrons by the strong force (colour confinement). Pulling quarks apart creates new quark-antiquark pairs.</div>
    </div>
  );
}

// ── Diagram 6: Heisenberg Uncertainty ───────────────────────────
function DiagramUncertainty() {
  const W = 860, H = 280;
  const well_localized = [];
  const spread_out = [];
  for (let x = 0; x <= 300; x += 3) {
    const p1 = 140 + 80 * Math.exp(-((x-150)*(x-150))/(2*15*15));
    well_localized.push(`${x+30},${p1}`);
    const p2 = 140 + 22 * Math.exp(-((x-150)*(x-150))/(2*55*55));
    spread_out.push(`${x+30},${p2}`);
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Heisenberg Uncertainty Principle — Position vs Momentum Trade-off</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Left: tightly localised */}
        <rect x={20} y={20} width={380} height={240} rx={8} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5"/>
        <text x={210} y={48} textAnchor="middle" fontSize="13" fontWeight="700" fill="#2E75B6">Well-Localised Position</text>
        <path d={'M '+well_localized.join(' L ')} fill="none" stroke="#2E75B6" strokeWidth="2.5"/>
        <path d={'M '+well_localized.join(' L ')+' L 330,220 L 30,220 Z'} fill="#2E75B6" opacity="0.12"/>
        <text x={210} y={225} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">Δx small → Δp LARGE (uncertain momentum)</text>

        {/* Right: spread out */}
        <rect x={440} y={20} width={400} height={240} rx={8} fill="#fff5f5" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={640} y={48} textAnchor="middle" fontSize="13" fontWeight="700" fill="#c0392b">Well-Defined Momentum</text>
        {/* Multiple spread waves */}
        {[-2,-1,0,1,2].map(offset => {
          const pts = [];
          for (let x=0; x<=350; x+=4) {
            const y = 140 + 30 * Math.sin((x/350)*Math.PI*8 + offset*0.8);
            pts.push(`${x+450},${y}`);
          }
          return <path key={offset} d={'M '+pts.join(' L ')} fill="none" stroke="#c0392b" strokeWidth="1.5" opacity="0.45"/>;
        })}
        <text x={640} y={225} textAnchor="middle" fontSize="11" fill="#2E75B6" fontWeight="700">Δp small → Δx LARGE (uncertain position)</text>

        <text x={430} y={145} textAnchor="middle" fontSize="22" fill="#7B0D0D" fontWeight="700">⟺</text>
      </svg>
      <div style={S.dCaption}>ΔxΔp ≥ ℏ/2. This is not a limitation of measurement instruments — it is a fundamental property of quantum fields. A perfectly localised particle would have infinite momentum uncertainty.</div>
    </div>
  );
}

export default function ParticleTheory() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Particle Theory in Physics</h1>

      <p style={S.p}>
        Particle physics seeks to answer the most fundamental question in science: what is the universe made of, and what holds it together? The answer, developed over a century of experiment and theory, is encoded in the <strong>Standard Model</strong> — one of the most successful scientific theories ever constructed, tested to a precision of one part in a trillion.
      </p>
      <p style={S.p}>
        At the deepest level we can probe, matter is not made of tiny billiard balls but of <strong>quantum fields</strong> that permeate all of space. Particles are localised excitations — ripples — in these fields. What we call an "electron" is a disturbance in the electron field; a "photon" is a ripple in the electromagnetic field. Every type of particle has its own corresponding field.
      </p>
      <p style={S.p}>
        The Standard Model classifies all known elementary particles into two families: <strong>fermions</strong> (matter particles with half-integer spin) and <strong>bosons</strong> (force carriers with integer spin). Fermions obey the Pauli exclusion principle; bosons do not. Within fermions there are quarks (which feel the strong force) and leptons (which do not). The forces themselves are mediated by the exchange of virtual gauge bosons.
      </p>

      <InfoBox title="What This Page Covers" items={[
        "The Standard Model: quarks, leptons, and gauge bosons",
        "Wave–particle duality and quantum field theory",
        "The four fundamental forces and their force carriers",
        "Hadron structure: baryons and mesons from quarks",
        "Feynman diagrams: visualising interactions",
        "Quantum mechanics: uncertainty principle, superposition, spin",
        "Conservation laws and symmetries (CPT, parity, baryon number)",
        "Beyond the Standard Model: dark matter, supersymmetry, string theory",
      ]}/>

      <h2 style={S.h2}>The Standard Model</h2>
      <p style={S.p}>
        The Standard Model (SM) is the theoretical framework describing all known elementary particles and three of the four fundamental forces (electromagnetic, weak nuclear, and strong nuclear). It was completed in the 1970s and has since survived every experimental test, culminating in the discovery of the Higgs boson at CERN in 2012. Gravity is not included in the Standard Model.
      </p>
      <DiagramStandardModel/>
      <Table2 rows={[
        ["Fermions","Matter particles; spin = ½ (or other half-integers)\nObey Fermi-Dirac statistics and the Pauli exclusion principle"],
        ["Quarks","6 flavours: up, down, charm, strange, top, bottom\nCarry colour charge; always confined inside hadrons"],
        ["Leptons","6 types: electron, muon, tau + their neutrinos\nDo not carry colour charge; neutrinos interact only via gravity and weak force"],
        ["Generations","Three generations of increasing mass; we are made of Generation I\nWhy exactly three generations is still unexplained"],
        ["Gauge Bosons","Spin-1 force carriers: photon (EM), W/Z (weak), gluons × 8 (strong)\nVirtual exchange of bosons mediates forces between fermions"],
        ["Higgs Boson","Spin-0 scalar boson discovered 2012; mass ≈ 125 GeV/c²\nField permeates all space; interactions with it give other particles their mass"],
        ["Antiparticles","Every particle has an antiparticle with opposite charge and quantum numbers\nMatter and antimatter annihilate on contact, releasing energy E = 2mc²"],
      ]}/>

      <h2 style={S.h2}>Wave–Particle Duality</h2>
      <p style={S.p}>
        One of the most counter-intuitive discoveries of 20th-century physics is that all quantum objects behave as both waves and particles simultaneously. An electron fired through a double slit produces an interference pattern — a wave phenomenon. Yet when detected, it arrives as a localised particle at a single point. The probability of finding the particle at any location is given by the squared amplitude of its <strong>wavefunction</strong> (|ψ|²).
      </p>
      <DiagramWaveParticle/>
      <Table2 rows={[
        ["De Broglie wavelength","λ = h / p = h / (mv)\nEvery particle has a wavelength inversely proportional to its momentum"],
        ["Double-slit experiment","Electrons/photons produce an interference pattern — even when fired one at a time\nInterference is with the particle's own probability wave"],
        ["Wavefunction ψ","Complex function containing all information about a quantum state\n|ψ(x)|² gives the probability density of finding the particle at position x"],
        ["Wavefunction collapse","Measurement forces the particle into a definite eigenstate\nThe wavefunction 'collapses' from superposition to a single outcome"],
        ["Complementarity","Wave and particle aspects are mutually exclusive\nThe more precisely one is observed, the less defined the other becomes"],
        ["Photon energy","E = hf = hc/λ\nh = Planck's constant = 6.626 × 10⁻³⁴ J·s"],
        ["Compton scattering","X-ray photon scatters off electron — wavelength shifts by Δλ = (h/mₑc)(1−cosθ)\nProved photons carry momentum"],
      ]}/>

      <h2 style={S.h2}>Quantum Mechanics — Core Principles</h2>
      <p style={S.p}>
        Quantum mechanics (QM) is the mathematical framework underlying all of particle physics. It replaces the deterministic trajectories of classical mechanics with probability amplitudes, and replaces continuous physical quantities with operators acting on a Hilbert space of quantum states.
      </p>
      <DiagramUncertainty/>
      <Table2 rows={[
        ["Heisenberg Uncertainty Principle","ΔxΔp ≥ ℏ/2  and  ΔEΔt ≥ ℏ/2\nFundamental, not due to instrument limitations"],
        ["Superposition","A quantum state can be a linear combination of multiple eigenstates\nMeasurement selects one outcome with probability |amplitude|²"],
        ["Spin","Intrinsic angular momentum — quantised in units of ℏ/2\nElectron spin = ½; photon spin = 1; Higgs spin = 0"],
        ["Pauli Exclusion Principle","No two identical fermions can occupy the same quantum state\nReason atoms have distinct electron shells and matter is stable"],
        ["Entanglement","Two particles share a quantum state; measuring one instantly determines the correlated property of the other — regardless of distance\n(No information travels — does not violate relativity)"],
        ["Schrödinger Equation","iℏ ∂ψ/∂t = Ĥψ\nGoverns how quantum states evolve in time (non-relativistic)"],
        ["Dirac Equation","(iγᵘ∂ᵤ − m)ψ = 0\nRelativistic quantum equation; predicted antimatter before it was discovered"],
        ["Quantum tunnelling","Particle passes through a classically forbidden energy barrier\nUnderpins nuclear fusion, radioactive decay, and tunnel diodes"],
      ]}/>

      <h2 style={S.h2}>The Four Fundamental Forces</h2>
      <p style={S.p}>
        All interactions in the universe arise from just four fundamental forces. Each is mediated by the exchange of one or more gauge bosons. Three of the four are described by the Standard Model using quantum field theory; gravity remains outside the SM and is described by Einstein's general relativity.
      </p>
      <DiagramForces/>
      <Table2 rows={[
        ["Strong Nuclear Force","Mediated by 8 massless gluons; acts on colour charge (quarks/gluons)\nRange: ~10⁻¹⁵ m; holds quarks inside protons, neutrons; holds nuclei together\nDescribed by Quantum Chromodynamics (QCD)"],
        ["Electromagnetic Force","Mediated by massless photons; acts on electric charge\nRange: infinite; responsible for chemistry, light, electricity, magnetism\nDescribed by Quantum Electrodynamics (QED) — precision: 1 part in 10¹²"],
        ["Weak Nuclear Force","Mediated by massive W± and Z⁰ bosons (~80–91 GeV/c²)\nRange: ~10⁻¹⁸ m; responsible for β-decay, neutrino interactions, nuclear fusion in stars\nOnly force that changes particle flavour (e.g. quark type)"],
        ["Gravity","Mediated by (hypothetical) graviton — spin-2, massless\nRange: infinite; always attractive; dominates at large scales\nNot included in Standard Model; described by General Relativity"],
        ["Electroweak unification","At energies above ~100 GeV, EM and weak forces unify into one electroweak force\nPredicted by Weinberg, Salam & Glashow; W/Z bosons confirmed 1983"],
        ["Grand Unification (GUT)","Theoretical unification of strong + electroweak at ~10¹⁵ GeV\nPredicts proton decay (not yet observed); several candidate theories"],
        ["Theory of Everything","Unification of all four forces including gravity — not yet achieved\nString theory, M-theory and loop quantum gravity are leading candidates"],
      ]}/>

      <h2 style={S.h2}>Quarks and the Strong Force (QCD)</h2>
      <p style={S.p}>
        Quarks carry a quantum number called <strong>colour charge</strong> — analogous to electric charge but with three varieties (red, green, blue) instead of one. The strong force, described by <strong>Quantum Chromodynamics (QCD)</strong>, binds quarks together via gluon exchange. Crucially, gluons themselves carry colour charge (unlike photons, which have no electric charge), making the strong force dramatically more complex than electromagnetism.
      </p>
      <DiagramHadrons/>
      <Table2 rows={[
        ["Colour charge","Three types: red, green, blue (and their anti-colours)\nAll observable hadrons are colour-neutral (white): RGB baryons or colour-anticolour mesons"],
        ["Gluons","8 types of massless gluon carrying a colour-anticolour combination\nSelf-interact because they carry colour — causes the force to grow with distance"],
        ["Colour confinement","As quarks separate, gluon field tube (flux tube) stretches; energy ~ k × r\nAt sufficient separation, energy creates new quark-antiquark pair — quarks never isolated"],
        ["Asymptotic freedom","At very short distances (high energy), quarks interact weakly — 'free'\nOpposite to intuition; Nobel Prize 2004 (Gross, Politzer, Wilczek)"],
        ["Baryons","Three quarks bound together; e.g., proton (uud), neutron (udd)\nBaryon number B = +1; conserved in all known interactions"],
        ["Mesons","Quark–antiquark pair; e.g., pion (ud̄), kaon (us̄)\nUnstable; decay via weak or EM force; B = 0"],
        ["Exotic hadrons","Tetraquarks (qqq̄q̄) and pentaquarks (qqqqq̄) confirmed at LHCb (2014–2020)\nExpands our picture of how quarks can combine"],
        ["Nuclear binding","Residual strong force (like van der Waals) between colour-neutral nucleons\nBinding energy per nucleon peaks at iron-56 — why fusion/fission both release energy"],
      ]}/>

      <h2 style={S.h2}>Feynman Diagrams and Interaction Vertices</h2>
      <p style={S.p}>
        Feynman diagrams are a powerful bookkeeping tool for calculating the probability amplitude of a particle interaction. Each diagram represents a term in the perturbation expansion of the S-matrix. Lines represent propagating particles; vertices represent interactions. The contribution of each diagram is a complex number; squaring the summed amplitude gives the observable probability.
      </p>
      <DiagramFeynman/>
      <Table2 rows={[
        ["Vertex rules","At each vertex, charge, lepton number, baryon number, colour, and energy-momentum must be conserved\nEach vertex contributes a factor of the coupling constant"],
        ["Coupling constant α","Fine structure constant for QED: α = e²/(4πε₀ℏc) ≈ 1/137\nSmall → perturbation theory converges well; QCD: αs ~1 at low energy"],
        ["Virtual particles","Internal lines in Feynman diagrams; not on-shell (E² ≠ p²c² + m²c⁴)\nCan have any mass — 'borrowed' energy from uncertainty principle"],
        ["Tree-level vs loops","Tree diagrams = leading order; loop diagrams add corrections ~αⁿ\nQED predictions match experiment to 12 decimal places using loop corrections"],
        ["Propagator","Internal particle propagator: 1/(p²−m²)\nHeavy virtual particles (e.g. W boson) give short-range interactions"],
        ["S-matrix","Relates initial and final quantum states in a scattering process\n|M|² gives the probability, used to calculate cross-sections and decay rates"],
      ]}/>

      <h2 style={S.h2}>Conservation Laws and Symmetries</h2>
      <p style={S.p}>
        Noether's theorem states that every continuous symmetry of the laws of physics corresponds to a conserved quantity. Particle physics is governed by deep symmetries — some exact, some violated. Understanding which symmetries are broken, and how, is key to understanding the universe.
      </p>
      <Table2 rows={[
        ["Energy-momentum","Conserved in all interactions (Poincaré symmetry)\nE² = (pc)² + (mc²)²  (relativistic dispersion relation)"],
        ["Electric charge","Conserved exactly; corresponding symmetry: U(1) phase invariance\nDerives from gauge invariance of the electromagnetic field"],
        ["Baryon number (B)","Conserved in all known SM interactions\nProton stability: τ > 10³⁴ years; GUT theories predict eventual decay"],
        ["Lepton number (Le, Lμ, Lτ)","Conserved separately for each generation in SM\nNeutrino oscillations violate individual lepton number but conserve total (L)"],
        ["Parity (P)","Mirror reflection; conserved by strong and EM, VIOLATED by weak force\nWu experiment (1956): β-decay prefers one handedness"],
        ["CP symmetry","Charge conjugation + parity; nearly conserved; small CP violation seen in kaons and B mesons\nCP violation required for matter-antimatter asymmetry to arise after Big Bang"],
        ["CPT theorem","Combined CPT symmetry is believed to be exact (Lorentz invariance + QFT)\nAll particles and antiparticles have identical mass and lifetime"],
        ["Isospin","Approximate symmetry between u and d quarks (nearly equal mass)\nExplains why proton and neutron have similar properties"],
        ["Colour SU(3)","Exact gauge symmetry of QCD; gluons are the gauge bosons\nColour is always conserved; all asymptotic states are colour singlets"],
      ]}/>

      <h2 style={S.h2}>Neutrinos and Neutrino Oscillations</h2>
      <p style={S.p}>
        Neutrinos are the most elusive particles in the Standard Model — electrically neutral, very nearly massless, and interacting only via the weak force and gravity. For decades the SM assumed they were exactly massless. The discovery of <strong>neutrino oscillations</strong> (Nobel Prize 2015, Kajita & McDonald) proved they have small but non-zero masses, requiring physics beyond the minimal SM.
      </p>
      <Table2 rows={[
        ["Three flavours","Electron neutrino (νe), muon neutrino (νμ), tau neutrino (ντ)\nEach associated with its charged lepton partner"],
        ["Neutrino oscillations","A νe produced in the Sun can be detected as νμ at Earth\nArises because flavour eigenstates ≠ mass eigenstates — they mix via PMNS matrix"],
        ["PMNS matrix","3×3 unitary matrix (like CKM for quarks) encoding mixing angles θ₁₂, θ₂₃, θ₁₃\nAlso contains a CP-violating phase δ — may explain matter dominance in universe"],
        ["Mass ordering","Normal hierarchy: m₁ < m₂ < m₃ vs inverted: m₃ < m₁ < m₂\nAbsolute masses unknown; Σmν < 0.12 eV from cosmological constraints"],
        ["Majorana vs Dirac","Are neutrinos their own antiparticles (Majorana) or distinct (Dirac)?\nNeutrinoless double beta decay would confirm Majorana nature — not yet observed"],
        ["Solar neutrino problem","Only ⅓ of predicted solar νe detected — solved by oscillations (SNO, 2002)\nConfirmed nuclear fusion powers the Sun and oscillations are real"],
      ]}/>

      <h2 style={S.h2}>The Higgs Mechanism and Mass</h2>
      <p style={S.p}>
        In the Standard Model, elementary particles do not have intrinsic mass. Instead, they acquire mass through their interaction with the <strong>Higgs field</strong>, which has a non-zero expectation value throughout all of space — even in a perfect vacuum. This is called spontaneous symmetry breaking. The stronger a particle's coupling to the Higgs field, the greater its mass.
      </p>
      <Table2 rows={[
        ["Higgs field","A scalar field with a 'Mexican hat' potential; VEV = 246 GeV\nOmnipresent in vacuum; breaks electroweak symmetry SU(2)×U(1) → U(1)EM"],
        ["Mass generation","Fermion masses: m = y × v / √2  (y = Yukawa coupling, v = 246 GeV)\nTop quark: y ≈ 1 (strongest coupling); electron: y ≈ 0.000003"],
        ["W and Z mass","Gauge bosons acquire mass via Higgs mechanism (not Yukawa)\nmW ≈ 80.4 GeV, mZ ≈ 91.2 GeV — confirmed with high precision at LEP"],
        ["Photon and gluon mass","Zero — photons and gluons do not couple to the Higgs field\nConsequence: electromagnetism and strong force are long-range"],
        ["Higgs boson","Quantum of the Higgs field; discovered at LHC July 4, 2012 (CMS & ATLAS)\nMass: 125.25 ± 0.17 GeV/c²; spin-0, CP-even"],
        ["Hierarchy problem","Why is the Higgs mass so much lighter than the Planck scale?\nQuantum corrections should drive mH to 10¹⁸ GeV — requires extraordinary 'fine-tuning'\nMain motivation for supersymmetry and other BSM theories"],
      ]}/>

      <h2 style={S.h2}>Beyond the Standard Model (BSM)</h2>
      <p style={S.p}>
        Despite its extraordinary success, the Standard Model is known to be incomplete. It does not explain dark matter, dark energy, the matter-antimatter asymmetry, the origin of neutrino masses, or why there are three generations. Several theoretical frameworks attempt to extend or replace it.
      </p>
      <Table2 rows={[
        ["Dark matter","~27% of universe's energy content; gravitational evidence from galaxies, CMB, lensing\nSM has no candidate; WIMPs, axions, sterile neutrinos are leading proposals"],
        ["Dark energy","~68% of energy; drives accelerating expansion of universe\nPossibly vacuum energy Λ (cosmological constant); equation of state w ≈ −1"],
        ["Supersymmetry (SUSY)","Every SM particle has a 'superpartner' with opposite spin statistics\nSolves hierarchy problem; provides dark matter candidate (neutralino); predicts Higgs mass\nNot yet confirmed at LHC — lower mass SUSY largely excluded"],
        ["String theory","Fundamental objects are 1D strings, not 0D points; vibration modes = particles\nRequires 10 or 11 dimensions; includes gravity naturally\nNo experimental predictions confirmed; not yet falsifiable at accessible energies"],
        ["Loop Quantum Gravity (LQG)","Quantises spacetime itself into discrete 'spin networks'\nBackground-independent approach; does not require extra dimensions\nDiffers from string theory in treatment of space and time"],
        ["Grand Unified Theories (GUT)","Unify strong, weak and EM into single gauge group at ~10¹⁵ GeV\nPredict proton decay (τ > 10³⁴ yr limit rules out SU(5))\nSO(10), SU(5), etc. remain viable"],
        ["Extra dimensions","Kaluza-Klein theories: extra compact spatial dimensions explain gauge forces\nLarge extra dimensions could lower Planck scale to TeV range\nSearched for at LHC via missing energy signatures"],
        ["Leptoquarks","Hypothetical bosons coupling quarks to leptons\nCould explain observed anomalies in B-meson decays (LHCb R_K measurements)"],
      ]}/>

      <h2 style={S.h2}>Particle Accelerators and Detectors</h2>
      <p style={S.p}>
        Probing shorter and shorter distance scales requires higher and higher energies (de Broglie: λ = h/p). Modern particle accelerators are the microscopes of particle physics — using powerful electric and magnetic fields to accelerate particles to near-light speeds and collide them.
      </p>
      <Table2 rows={[
        ["Large Hadron Collider (LHC)","Located at CERN, Geneva; circumference 27 km; pp collisions at √s = 13.6 TeV\nDiscovered Higgs boson 2012; exploring BSM at TeV scale"],
        ["Linear accelerators","Particles accelerated in a straight line using RF cavities\nAvoid synchrotron radiation losses — preferred for electrons at high energy"],
        ["Synchrotron","Circular ring; magnetic field increased as particle gains energy to keep same radius\nSynchrotron radiation emitted — useful for materials science, medicine"],
        ["Cyclotron","Fixed-frequency RF + fixed magnetic field; limited to non-relativistic energies\nUsed in medical facilities for proton therapy and radioisotope production"],
        ["Detector layers","1. Tracker (inner): reconstructs charged particle tracks\n2. Calorimeter: measures energy of EM and hadronic showers\n3. Muon chambers (outer): muons penetrate all inner layers"],
        ["Missing transverse energy","Momentum imbalance in transverse plane indicates invisible particles (neutrinos, dark matter)\nKey signature for SUSY, dark matter searches"],
        ["Monte Carlo simulation","Random sampling used to simulate millions of collision events\nCompared to data to test theory predictions and discover anomalies"],
        ["Luminosity","L = number of collisions per unit area per unit time\nHigher luminosity → more rare events; LHC: L ≈ 2 × 10³⁴ cm⁻² s⁻¹"],
      ]}/>

      <InfoBox title="Key Equations of Particle Physics" items={[
        "Relativistic energy-momentum: E² = (pc)² + (mc²)²",
        "De Broglie wavelength: λ = h/p = h/(mv)",
        "Heisenberg uncertainty: ΔxΔp ≥ ℏ/2  and  ΔEΔt ≥ ℏ/2",
        "Fermion mass (Yukawa): m_f = y_f × v/√2  (v = 246 GeV, Higgs VEV)",
        "Fine structure constant: α = e²/(4πε₀ℏc) ≈ 1/137  (QED coupling)",
        "QCD running coupling: αs(mZ) ≈ 0.118 (decreases at high energy — asymptotic freedom)",
        "Dirac equation: (iγᵘ∂_μ − m)ψ = 0  (relativistic quantum field theory)",
        "Breit-Wigner resonance: σ ∝ Γ² / [(E−M)² + Γ²/4]  (particle widths/lifetimes)",
        "Cross-section from amplitude: σ = (1/flux) × |⟨f|S|i⟩|² (S-matrix element)",
        "CKM matrix: encodes quark flavour mixing and CP violation in weak decays",
      ]}/>
    </div>
  );
}